import { jsx as t } from "react/jsx-runtime";
const i = ({ href: r, children: n, rel: e, ...o }) => /* @__PURE__ */ t("a", { target: "_blank", rel: `noopener noreferrer${e ? ` ${e}` : ""}`, href: r, ...o, children: n ?? r });
export {
  i as ExternalLink
};
